import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {ProgressBarModule} from "angular-progress-bar";

import { AppComponent } from './app.component';
import { AnswersElementComponent } from './answers-element/answers-element.component';
import { HttpClientModule } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    AnswersElementComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ProgressBarModule,
  ],
  providers: [HttpClientModule, HttpClient],
  bootstrap: [AppComponent]
})
export class AppModule { }
